import React from 'react';
import PropTypes from 'prop-types';
import { Components, translate, Utils } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import moment from 'moment';

const {
  Helper,
} = Utils;

class ActionPanelFilterTaskContactPersonButton extends React.Component {
  componentDidMount() {
    this.props.dispatch(ReduxActions.task.fetchAddressesOptionList(this.props.date));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      this.props.dispatch(ReduxActions.task.fetchAddressesOptionList(this.props.date));
    }
  }

  render() {
    const {
      id, value, onChange, optionAddresses, strings,
      className, filterClassName, children,
    } = this.props;
    const options = (optionAddresses || []).map(option => ({
      value: option.contact_person, text: option.contact_person,
    }));

    let text;
    if (value.length <= 1) {
      text = strings.taskContactPerson.item;
    } else {
      text = `${value.length > 1 && value.length < options.length
        ? strings.multiple : strings.all} ${strings.taskContactPerson.itemPlural}`;
    }

    const subText = value.length === 1 && options.length > 0 ? (options.find(
      option => value[0] === option.value,
    ) || {}).text : undefined;

    // Filter values that are available in the account options
    const filteredValues = value.filter(contactPersonName => options.some(
      option => option.value === contactPersonName,
    ));

    return (
      <Components.ActionPanel.DropdownButton
        className={className}
        id={Helper.isNullOrUndefined(id) ? undefined : `${id}__dropdown-button`}
        showArrow
        subText={subText}
        text={text}
      >
        {children}
        <Components.ActionPanel.FilterTagDropdown
          className={filterClassName}
          error={strings.taskContactPerson.error}
          id={Helper.isNullOrUndefined(id) ? undefined : `${id}__filter-tag-dropdown`}
          onChange={v => onChange(v)}
          options={options}
          placeholder={strings.taskContactPerson.placeholder}
          value={filteredValues}
        />
      </Components.ActionPanel.DropdownButton>
    );
  }
}

ActionPanelFilterTaskContactPersonButton.displayName = 'Action Panel Filter Task Contact Person Button';

ActionPanelFilterTaskContactPersonButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  dispatch: PropTypes.func.isRequired,
  filterClassName: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape()),
  strings: PropTypes.shape({
    taskContactPerson: PropTypes.shape({
      error: PropTypes.string,
      item: PropTypes.string,
      itemPlural: PropTypes.string,
      placeholder: PropTypes.string,
    }),
    multiple: PropTypes.string,
    all: PropTypes.string,
  }).isRequired,
  value: PropTypes.arrayOf(PropTypes.number),
};

ActionPanelFilterTaskContactPersonButton.defaultProps = {
  className: '',
  children: null,
  date: moment().format('YYYY-MM-DD'),
  filterClassName: '',
  id: '',
  onChange: null,
  optionAddresses: [],
  value: [],
};

function mapStateToProps(state) {
  const { task } = state;
  return {
    optionAddresses: task.optionAddresses,
  };
}

export default connect(mapStateToProps)(translate('Task.filter')(ActionPanelFilterTaskContactPersonButton));
